function generateGeometry() {
  let x = (Math.random() * (2580391 - 1651561) + 1651561).toFixed(2);
  let y = (Math.random() * (7209537 - 6424431) + 6424431).toFixed(2);
  return {
    type: 'Feature',
    geometry: {
      type: 'Point',
      coordinates: [parseFloat(x), parseFloat(y)]
    }
  };
}

export const wojOptions = [{
    value: 'dolnośląskie',
    name: 'Dolnośląskie'
  },
  {
    value: 'kujawsko-pomorskie',
    name: 'Kujawsko-pomorskie'
  },
  {
    value: 'lubelskie',
    name: 'Lubelskie'
  },
  {
    value: 'lubuskie',
    name: 'Lubuskie'
  },
  {
    value: 'łódzkie',
    name: 'Łódzkie'
  },
  {
    value: 'małopolskie',
    name: 'Małopolskie'
  },
  {
    value: 'mazowieckie',
    name: 'Mazowieckie'
  },
  {
    value: 'opolskie',
    name: 'Opolskie'
  },
  {
    value: 'podkarpackie',
    name: 'Podkarpackie'
  },
  {
    value: 'podlaskie',
    name: 'Podlaskie'
  },
  {
    value: 'pomorskie',
    name: 'Pomorskie'
  },
  {
    value: 'śląskie',
    name: 'Śląskie'
  },
  {
    value: 'świętokrzyskie',
    name: 'Świętokrzyskie'
  },
  {
    value: 'warmińsko-mazurskie',
    name: 'Warmińsko-mazurskie'
  },
  {
    value: 'wielkopolskie',
    name: 'Wielkopolskie'
  },
  {
    value: 'zachodniopomorskie',
    name: 'Zachodniopomorskie'
  }
];

function generateRandomData() {
  let data = [];
  for (let idx of [...Array(30).keys()]) {
    data.push({
      id: idx + 1,
      name: `Teren inwestycyjny ${idx + 1}`,
      countParcels: parseFloat((Math.random() * (10 - 1) + 1).toFixed(0)),
      area: parseFloat((Math.random() * (100 - 10) + 10).toFixed(2)),
      status: Math.random() >= 0.5,
      woj: wojOptions[(Math.random() * 15).toFixed(0)].value,
      geometry: generateGeometry(),
      owner: idx % 2 ? 'CBRE' : 'pub'
    });
  }
  return data;
}

export const TEST_DATA = generateRandomData();

export const TEST_HEADERS = [{
    text: null,
    value: '',
    type: 'text',
    sortable: false
  },
  {
    text: 'name',
    value: 'name',
    type: 'text'
  },
  {
    text: 'woj',
    value: 'woj',
    type: 'text'
  },
  {
    text: 'countParcels',
    value: 'countParcels'
  },
  {
    text: 'area',
    value: 'area',
    type: 'number'
  },
  {
    text: 'status',
    value: 'status',
    type: 'boolean'
  },
  {
    text: 'tools',
    value: 'tools',
    align: 'center',
    sortable: false
  }
];

export const TEST_HEADERS_CHANGES = [{
    text: 'date',
    value: 'date',
    type: 'date',
    align: 'center'
  },
  {
    text: 'change',
    value: 'change',
    type: 'text',
    align: 'center'
  }
];

export const TEST_HEADERS_STATS = [
  {
    text: 'creationDate',
    value: 'creationDate',
    type: 'date'
  },
  {
    text: 'description',
    value: 'description',
    type: 'text'
  },
  {
    text: 'tools',
    value: 'tools',
    align: 'center',
    sortable: false
  }
];

export const TEST_HEADERS_ACTIVITY = [
  /* {
    text: null,
    value: '',
    type: 'text',
    sortable: false
  }, */
  {
    text: 'dateAndTime',
    value: 'dateAndTime',
    type: 'datetime'
  },
  {
    text: 'description',
    value: 'description',
    type: 'text'
  }
];

export const TEST_LINK_ACTIVITY = [{
    text: 'name',
    value: 'name',
    type: 'text'
  },
  {
    text: 'offerViews',
    value: 'offerViews',
    type: 'text'
  }
];

export const TEST_ATTRIBUTES = {
  access: [{
      name: 'dostep_dzialka',
      type: 'text',
      value: null
    },
    {
      name: 'dostep_drogowy',
      type: 'text',
      value: null
    },
    {
      name: 'dr_do_dzialki',
      type: 'text',
      value: null
    },
    {
      name: 'info_dr_dojazdowa',
      type: 'text',
      value: null
    },
    {
      name: 'ogr_tonazowe',
      type: 'text',
      value: null
    },
    {
      name: 'dost_bocznica',
      type: 'text',
      value: null
    },
    {
      name: 'odl_od_autostrady',
      type: 'text',
      value: null
    },
    {
      name: 'dostep_do',
      type: 'text',
      value: null
    },
    {
      name: 'kom_publiczna',
      type: 'text',
      value: null
    },
    {
      name: 'odl_porty_lotn',
      type: 'text',
      value: null
    },
    {
      name: 'dost_porty_lotn',
      type: 'text',
      value: null
    }
  ],
  acquisition: [{
    label_en: '',
    label_pl: 'Procedura nabycia',
    name: 'procedura_nabycia',
    translate: false,
    type: 'select',
    value: null
  }],
  building: [{
      name: 'mapa_nakr_bud',
      type: 'text',
      value: null
    },
    {
      name: 'info_zabud',
      type: 'text',
      value: null
    },
    {
      name: 'istniejaca_zabud',
      type: 'text',
      value: null
    },
    {
      name: 'ilosc_bud',
      type: 'text',
      value: null
    },
    {
      name: 'klasa_obiektu',
      type: 'text',
      value: null
    },
    {
      name: 'budynki_pow',
      type: 'text',
      value: null
    },
    {
      name: 'biura_pow',
      type: 'text',
      value: null
    },
    {
      name: 'prod_pow',
      type: 'text',
      value: null
    },
    {
      name: 'magazyn_pow',
      type: 'text',
      value: null
    },
    {
      name: 'opis_obiektow',
      type: 'text',
      value: null
    },
    {
      name: 'spec_techniczna',
      type: 'text',
      value: null
    },
    {
      name: 'siatka_slupow',
      type: 'text',
      value: null
    },
    {
      name: 'wysokosc_bud',
      type: 'text',
      value: null
    },
    {
      name: 'nosnosc_posadzki',
      type: 'text',
      value: null
    },
    {
      name: 'bramy_wjazdowe',
      type: 'text',
      value: null
    },
    {
      name: 'ilosc_dokow',
      type: 'text',
      value: null
    },
    {
      name: 'ogrzewanie',
      type: 'text',
      value: null
    },
    {
      name: 'spec_tech_biuro',
      type: 'text',
      value: null
    },
    {
      name: 'powierzchnia',
      type: 'text',
      value: null
    },
    {
      name: 'ilosc_kondygnacji',
      type: 'text',
      value: null
    },
    {
      name: 'dodatkowe_instalacje',
      type: 'text',
      value: null
    }
  ],
  localization: [{
      label_en: 'Location description',
      label_pl: 'Opis lokalizacji',
      name: 'lokalizacja_opis',
      translate: true,
      type: 'text',
      value: null
    },
    {
      label_en: 'Voivodship',
      label_pl: 'Wojew\u00f3dztwo',
      name: 'wojewodztwo',
      translate: false,
      type: 'select',
      value: null
    },
    {
      label_en: '',
      label_pl: 'Powiat',
      name: 'powiat',
      translate: false,
      type: 'select',
      value: null
    },
    {
      label_en: '',
      label_pl: 'Gmina',
      name: 'gmina',
      translate: false,
      type: 'select',
      value: null
    },
    {
      label_en: '',
      label_pl: 'Miasto',
      name: 'miasto',
      translate: false,
      type: 'text',
      value: null
    },
    {
      label_en: '',
      label_pl: 'Ulica',
      name: 'ulica',
      translate: false,
      type: 'text',
      value: null
    },
    {
      label_en: '',
      label_pl: 'Kod pocztowy',
      name: 'kod_pocztowy',
      translate: false,
      type: 'text',
      value: null
    },
    {
      label_en: '',
      label_pl: 'Wsp\u00f3\u0142rz\u0119dne geograficzne',
      name: 'wsp_geogr',
      translate: false,
      type: 'disabled',
      value: null
    },
    {
      label_en: '',
      label_pl: 'Specjalna Strefa Ekonomiczna',
      name: 'sse',
      translate: false,
      type: 'boolean',
      value: null
    },
    {
      label_en: '',
      label_pl: 'Powierzchnia dzia\u0142ki',
      name: 'pow_dzialki',
      translate: false,
      type: 'number',
      value: null
    },
    {
      label_en: '',
      label_pl: 'Mo\u017cliwo\u015b\u0107 podzia\u0142u',
      name: 'podzial_dzialki',
      translate: false,
      type: 'boolean',
      value: null
    },
    {
      label_en: '',
      label_pl: 'Mo\u017cliwo\u015b\u0107 ekspansji',
      name: 'ekspansja',
      translate: false,
      type: 'boolean',
      value: null
    },
    {
      label_en: '',
      label_pl: 'Ukszta\u0142towanie terenu',
      name: 'uksztaltowanie_ter',
      translate: false,
      type: 'text',
      value: null
    },
    {
      label_en: '',
      label_pl: 'Wymiary dzia\u0142ki',
      name: 'wymiary_dzialki',
      translate: false,
      type: 'text',
      value: null
    },
    {
      label_en: '',
      label_pl: 'Gleba',
      name: 'gleba',
      translate: false,
      type: 'text',
      value: null
    },
    {
      label_en: '',
      label_pl: 'Obecne u\u017cytkowanie terenu',
      name: 'obecne_uzytkowanie',
      translate: false,
      type: 'text',
      value: null
    },
    {
      label_en: '',
      label_pl: 'Drzewostan',
      name: 'drzewostan',
      translate: false,
      type: 'text',
      value: null
    },
    {
      label_en: '',
      label_pl: 'Klasa bonitacyjna i powierzchnia',
      name: 'pow_kl_bonitacyjna',
      translate: false,
      type: 'number',
      value: null
    },
    {
      label_en: '',
      label_pl: 'Zanieczyszczenie gleby',
      name: 'zanieczyszczenie_gleby',
      translate: false,
      type: 'text',
      value: null
    },
    {
      label_en: '',
      label_pl: 'Inne informacje o glebie',
      name: 'info_gleba',
      translate: false,
      type: 'text',
      value: null
    }
  ],
  media: [{
      name: 'media',
      type: 'text',
      value: null
    },
    {
      name: 'dost_media',
      type: 'text',
      value: null
    },
    {
      name: 'en_elektr',
      type: 'text',
      value: null
    },
    {
      name: 'gaz',
      type: 'text',
      value: null
    },
    {
      name: 'woda',
      type: 'text',
      value: null
    },
    {
      name: 'kanalizacja',
      type: 'text',
      value: null
    },
    {
      name: 'linia_telefon',
      type: 'text',
      value: null
    }
  ],
  name: [{
      label_en: 'Property name',
      label_pl: 'Nazwa nieruchomo\u015bci',
      name: 'nazwa_nieruchomosci',
      translate: true,
      type: 'text',
      value: 'Test'
    },
    {
      label_en: 'Parcel number',
      label_pl: 'Numer dzia\u0142ki',
      name: 'nr_ew_dzialek',
      translate: false,
      type: 'text',
      value: null
    },
    {
      label_en: 'Precint number',
      label_pl: 'Numer obr\u0119bu',
      name: 'nr_obre',
      translate: false,
      type: 'text',
      value: null
    },
    {
      label_en: 'Land and mortgage register number',
      label_pl: 'Numer ksi\u0119gi wieczystej',
      name: 'nr_kw',
      translate: false,
      type: 'text',
      value: null
    }
  ],
  others: [{
      name: 'ryzyka',
      type: 'text',
      value: null
    },
    {
      name: 'ob_ochr_archeolog',
      type: 'text',
      value: null
    },
    {
      name: 'ob_ochr_prz',
      type: 'text',
      value: null
    },
    {
      name: 'itd',
      type: 'text',
      value: null
    },
    {
      name: 'korzysci',
      type: 'text',
      value: null
    },
    {
      name: 'umowa_posrednictwa',
      type: 'text',
      value: null
    },
    {
      name: 'opis_nieruch',
      type: 'text',
      value: null
    },
    {
      name: 'nieruch_dane_gus',
      type: 'text',
      value: null
    },
    {
      name: 'data_ost_nabycia',
      type: 'text',
      value: null
    },
    {
      name: 'zalaczniki_dokumentacja',
      type: 'text',
      value: null
    },
    {
      name: 'zal_graf_mpzp',
      type: 'text',
      value: null
    },
    {
      name: 'wypis_rej_gruntow',
      type: 'text',
      value: null
    },
    {
      name: 'odp_ksiegi_wiecz',
      type: 'text',
      value: null
    },
    {
      name: 'wypis_wyrys_mpzp',
      type: 'text',
      value: null
    },
    {
      name: 'bad_geotechn_gruntu',
      type: 'text',
      value: null
    },
    {
      name: 'bad_zan_gruntu',
      type: 'text',
      value: null
    },
    {
      name: 'inwentar_drzewostanu',
      type: 'text',
      value: null
    },
    {
      name: 'wys_podatku_od_nieruch',
      type: 'text',
      value: null
    },
    {
      name: 'dojazd_z_drpublicznej',
      type: 'text',
      value: null
    },
    {
      name: 'zdjecia',
      type: 'text',
      value: null
    },
    {
      name: 'prezentacje',
      type: 'text',
      value: null
    },
    {
      name: 'inne',
      type: 'text',
      value: null
    },
    {
      name: 'nazwy_ofert_proj',
      type: 'text',
      value: null
    }
  ],
  ownership: [{
      label_en: '',
      label_pl: 'W\u0142a\u015bciciel',
      name: 'wlasnosc',
      translate: false,
      type: 'text',
      value: null
    },
    {
      label_en: '',
      label_pl: 'Typ w\u0142a\u015bciciela',
      name: 'wlasciciel_typ',
      translate: false,
      type: 'select',
      value: null
    },
    {
      label_en: '',
      label_pl: 'Szczeg\u00f3\u0142y w\u0142a\u015bcicieli',
      name: 'wlasciciele',
      translate: false,
      type: 'text',
      value: null
    }
  ],
  price: [{
    label_en: '',
    label_pl: 'Cena zakupu',
    name: 'cena_zakupu',
    translate: false,
    type: 'text',
    value: null
  }],
  spatial_planning: [{
      label_en: '',
      label_pl: 'Plany przestrzenne',
      name: 'plan_przestrzenne',
      translate: false,
      type: 'text',
      value: null
    },
    {
      label_en: '',
      label_pl: 'Nazwa MPZP',
      name: 'nazwa_mpzp',
      translate: false,
      type: 'text',
      value: null
    },
    {
      label_en: '',
      label_pl: 'Stan planistyczny',
      name: 'stan_plan',
      translate: false,
      type: 'select',
      value: null
    },
    {
      label_en: '',
      label_pl: 'Typ strefy/zabudowy',
      name: 'typ_strefa',
      translate: false,
      type: 'select',
      value: null
    },
    {
      label_en: '',
      label_pl: 'Cel wed\u0142ug zastosowania terenu',
      name: 'cel',
      translate: false,
      type: 'select',
      value: null
    },
    {
      label_en: '',
      label_pl: 'Ograniczenia zabudowy',
      name: 'ograniczenia_zabud',
      translate: false,
      type: 'text',
      value: null
    },
    {
      label_en: '',
      label_pl: 'Powierzchnia biologicznie czynna',
      name: 'czynna_pow_biol',
      translate: false,
      type: 'text',
      value: null
    },
    {
      label_en: '',
      label_pl: 'Maksymalna powierzchnia zabudowy',
      name: 'zabud_pow_max',
      translate: false,
      type: 'text',
      value: null
    },
    {
      label_en: '',
      label_pl: 'Maksymalna wysoko\u015b\u0107 zabudowy',
      name: 'max_h_zabud',
      translate: false,
      type: 'text',
      value: null
    },
    {
      label_en: '',
      label_pl: 'Inne',
      name: 'inne_wskaznik',
      translate: false,
      type: 'text',
      value: null
    }
  ]
};

function getRandomAttachments() {
  let data = [];
  for (let idx of [...Array(30).keys()]) {
    data.push({
      id: idx + 1,
      name: `Załącznik ${idx + 1}`,
      pl: `Załącznik ${idx + 1}`,
      en: `Attachment ${idx + 1}`,
      datetime: randomDate(new Date(2015, 0, 1), new Date()),
      user: idx % 2 ? 'CBRE' : 'pub'
    });
  }
  return data;
}

export const ATTACHMENTS = {
  meta: [{
      text: 'name',
      value: 'name',
      type: 'text'
    },

    {
      text: 'pl',
      value: 'pl',
      type: 'text'
    },
    {
      text: 'en',
      value: 'en',
      type: 'text'
    },
    {
      text: 'datetime',
      value: 'datetime',
      type: 'text'
    },
    {
      text: 'user',
      type: 'text',
      value: 'user'
    },
    {
      text: 'tools',
      value: 'tools',
      align: 'center',
      sortable: false
    }
  ],
  attachments: getRandomAttachments()
};

function randomDate(start, end) {
  return new Date(
    start.getTime() + Math.random() * (end.getTime() - start.getTime())
  );
}

function getRandomComments() {
  let data = [];
  for (let idx of [...Array(30).keys()]) {
    data.push({
      id: idx + 1,
      content: `Komentarz ${idx + 1}`,
      status: idx % 2 ? 'D' : 'E',
      datetime: randomDate(new Date(2015, 0, 1), new Date()),
      user: idx % 2 ? 'M0X' : 'M1X'
    });
  }
  return data;
}

export const COMMENTS = {
  meta: [{
      text: 'content',
      value: 'content',
      type: 'text'
    },
    {
      text: 'datetime',
      value: 'datetime',
      type: 'date'
    },
    {
      text: 'status',
      value: 'status',
      type: 'text'
    },
    {
      text: 'user',
      type: 'text',
      value: 'user'
    },
    {
      text: 'tools',
      value: 'tools',
      align: 'center',
      sortable: false
    }
  ],
  comments: getRandomComments()
};

function getRandomParcels() {
  let data = [];
  for (let idx of [...Array(30).keys()]) {
    data.push({
      id: idx + 1,
      number: `NUMER ${idx + 1}`,
      status: idx % 2 ? '1' : '2',
      area: (Math.random() * (7209 - 6424) + 6424).toFixed(2),
      owner: idx % 2 ? 'CBRE' : 'pub',
      geometry: generateGeometry(),
      comments: (Math.random() * (51 - 11) + 11).toFixed(0)
    });
  }
  return data;
}

export const PARCELS = {
  meta: [{
      text: 'number',
      value: 'number',
      type: 'text'
    },
    {
      text: 'owner',
      value: 'owner',
      type: 'text'
    },
    {
      text: 'area',
      value: 'area',
      type: 'number'
    },
    {
      text: 'status',
      type: 'text',
      value: 'status'
    },
    {
      text: 'tools',
      value: 'tools',
      align: 'center',
      sortable: false
    }
  ],
  parcels: getRandomParcels()
};

function getRandomProjects() {
  let data = [];
  for (let i in [...Array(30).keys()]) {
    let obj = {
      id: Number(i) + 1,
      projectName: `Projekt ${Number(i) + 1}`,
      description: `Opis ${Number(i) + 1}`,
      offers: []
    };
    for (let j in [...Array(5).keys()]) {
      obj.offers.push(Math.ceil(Math.random() * (29 - j) + j + 1));
    }
    data.push(obj);
  }
  return data;
}

export const PROJECTS = {
  meta: [{
      text: 'projectName',
      type: 'text',
      value: 'projectName'
    },
    {
      text: 'tools',
      value: 'tools',
      align: 'center',
      sortable: false
    }
  ],
  projects: getRandomProjects()
};
